import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@tanstack/react-start";
import { officeListOrders } from "@/lib/office.functions";

export const Route = createFileRoute("/_employee/medewerker/office/orders")({
  head: () => ({ meta: [{ title: "Orders — EVG Office" }, { name: "robots", content: "noindex" }] }),
  component: Orders,
});

function fmt(c: number) {
  return new Intl.NumberFormat("nl-NL", { style: "currency", currency: "EUR" }).format(c / 100);
}

function Orders() {
  const list = useServerFn(officeListOrders);
  const { data, isLoading } = useQuery({ queryKey: ["office-orders"], queryFn: () => list() });
  return (
    <div className="space-y-5">
      <h1 className="text-2xl font-bold text-slate-900">Orders</h1>
      <div className="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-slate-200">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-xs uppercase text-slate-500">
            <tr>
              <th className="p-3 text-left">Nr.</th>
              <th className="p-3 text-left">Klant</th>
              <th className="p-3 text-left">Status</th>
              <th className="p-3 text-right">Totaal</th>
              <th className="p-3 text-left">Datum</th>
              <th className="p-3 text-left">Chat</th>
            </tr>
          </thead>
          <tbody>
            {isLoading ? <tr><td colSpan={6} className="p-8 text-center text-slate-400">Laden…</td></tr>
            : (data?.orders ?? []).map((o: any) => (
              <tr key={o.id} className="border-t border-slate-100 hover:bg-slate-50/50">
                <td className="p-3 font-mono text-xs">{o.order_number}</td>
                <td className="p-3">{o.customer_name ?? <span className="text-slate-400">—</span>}</td>
                <td className="p-3"><span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs">{o.status}</span></td>
                <td className="p-3 text-right font-semibold">{fmt(o.total_cents)}</td>
                <td className="p-3 text-xs text-slate-500">{new Date(o.created_at).toLocaleDateString("nl-NL")}</td>
                <td className="p-3">
                  {o.customer_phone ? (
                    <a
                      href={`/admin/whatsapp?phone=${encodeURIComponent(o.customer_phone)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-flex items-center gap-1 rounded border border-emerald-300 bg-emerald-50 px-2 py-0.5 text-[11px] font-medium text-emerald-800 hover:bg-emerald-100"
                      title={`Open WhatsApp-chat met ${o.customer_name ?? o.customer_phone}`}
                    >
                      💬 Open chat
                    </a>
                  ) : (
                    <span className="text-[11px] text-slate-400">geen nummer</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
